





























import ZastosowaniaSheet from "./ZastosowaniaSheet.vue";
import IngredientsSheet from "./IngredientsSheet.vue";
import Vue from "vue";
import { Receptura } from "@megarax/client/src/resources/plm/Receptura";
import { sheetOptionsSymbol } from "@/components/sheet/SheetEntries";
import { createComponent, provide } from "@vue/composition-api";
import DefaultRevisionSheet from "@/components/DefaultRevisionSheet.vue";

export default createComponent({
  components: {
    ZastosowaniaSheet,
    IngredientsSheet,

    DefaultRevisionSheet,
  },
  name: "RecepturaSheet",
  props: {
    value: {
      type: Receptura,
      required: true,
    },
  },

  setup(props, ctx) {
    return {};
  },
});
